import { Button, Col, Modal, Row, Space } from 'antd';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { WorkRecord } from '../../modules/work-records';
import WorkRecordPrintComponent from './WorkRecordPrintComponent';

interface WorkRecordPrintModalProps {
  visible: boolean;
  workRecord: WorkRecord;
  project: any;
  onCancel: () => void;
}
function WorkRecordPrintModal({
  visible,
  workRecord,
  project,
  onCancel,
}: WorkRecordPrintModalProps) {
  const componentRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `[작업일보][${workRecord.createdDate}] ${project.name}`,
  });

  return (
    <>
      <Modal
        visible={visible}
        title={
          <>
            <Row justify="space-between">
              <Col>
                <span>작업일보</span>
              </Col>
              <Col style={{ marginRight: '30px' }}>
                <Space>
                  <Col>
                    <Button onClick={handlePrint}>프린트</Button>
                  </Col>
                </Space>
              </Col>
            </Row>
          </>
        }
        onCancel={onCancel}
        width={1000}
        footer={null}
      >
        <Row>
          <Col flex={1}>
            <WorkRecordPrintComponent
              workRecord={workRecord}
              project={project}
              ref={componentRef}
            />
          </Col>
        </Row>
      </Modal>
    </>
  );
}

export default WorkRecordPrintModal;
